import { PAIRED_SALES_SINGLE_API } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  UpdatePairedSalesStudyError,
  UpdatePairedSalesStudyVariables,
  fetchUpdatePairedSalesStudy,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = PAIRED_SALES_SINGLE_API.PUT;

export const useUpdatePairedSalesStudy = (
  options?: Omit<
    UseMutationOptions<
      z.infer<typeof API_SCHEMA.RESPONSE>,
      UpdatePairedSalesStudyError,
      UpdatePairedSalesStudyVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<
    z.infer<typeof API_SCHEMA.RESPONSE>,
    UpdatePairedSalesStudyError,
    UpdatePairedSalesStudyVariables
  >({
    mutationFn: (variables: UpdatePairedSalesStudyVariables) =>
      fetchUpdatePairedSalesStudy({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
